import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, Observable, of, tap, throwError } from 'rxjs';
import { BaseRespone } from 'src/app/models/common.response';
import { environment } from 'src/environments/environment';
import { IMedicalCertificate } from './imedical.type';

@Injectable({
    providedIn: 'root'
})
export class MedicalCertificateService {

    constructor(private _httpClient: HttpClient) { }

    saveMedicalCertificate(certificate: IMedicalCertificate): Observable<BaseRespone<IMedicalCertificate>> {
        return this._httpClient.post<BaseRespone<IMedicalCertificate>>(`${environment.baseURl}/MedicalCertificate`, certificate)
            .pipe(
                catchError((error) => {
                    return of(error.error);
                }),
                map((newcertificate) => {
                    // Return the new certificate
                    return newcertificate;
                })
            )
    }

    getMedicalCertificateByPatientId(patientId: number) {
        return this._httpClient.get<BaseRespone<IMedicalCertificate>>(`${environment.baseURl}/MedicalCertificate/patient/${patientId}`)
            .pipe(
                map(response => response.result),
                catchError(error => {
                    console.error('Error fetching Medical Certificate by Patient ID:', error);
                    return throwError(() => error.error);
                })
            );
    }

    getMedicalCertificateByIpdId(ipdid: number) {
        return this._httpClient.get<BaseRespone<IMedicalCertificate>>(`${environment.baseURl}/MedicalCertificate/ipd/${ipdid}`)
            .pipe(
                map(response => response.result),
                catchError(error => {
                    console.error('Error fetching Medical Certificate by IPD ID:', error);
                    return throwError(() => error.error);
                })
            );
    }
}